import React from "react";
import CandlestickLoader from "@/components/common/CandlestickLoader";

interface StudyResultsLoaderProps {
  isLoading: boolean;
  onComplete?: () => void;
  estimatedDuration?: number; // in seconds
}

const STUDY_RESULTS_MESSAGES = [
  "Replaying every trial tick",
  "Extracting alpha from the noise floor",
  "Charting parameter constellations",
  "Synthesizing performance telemetry",
  "Polishing the insights dashboard",
];

const StudyResultsLoader: React.FC<StudyResultsLoaderProps> = ({
  isLoading,
  onComplete,
  estimatedDuration = 15,
}) => {
  return (
    <CandlestickLoader
      isLoading={isLoading}
      {...(onComplete && { onComplete })}
      estimatedDuration={estimatedDuration}
      messages={STUDY_RESULTS_MESSAGES}
      containerClassName="w-full min-h-[70vh] px-6"
      messageClassName="text-slate-200"
      context="StudyResultsLoader"
    />
  );
};

export default StudyResultsLoader;
